import { useRef } from "react";
import Flex from "../flex";

import MuiImageList, { ImageListProps as MuiImageListProps } from "@mui/material/ImageList";
import MuiImageListItem, { ImageListItemProps as MuiImageListItemProps } from "@mui/material/ImageListItem";
import MuiSkeleton from "@mui/material/Skeleton";

export interface ImageListProps extends MuiImageListProps {
  columnCount?: number;
  isLoading?: boolean;
  itemWidth: number;
}

export interface ImageListItemProps extends MuiImageListItemProps {
  imageHeight?: number;
  imageWidth?: number;
}

export const ImageListItem: React.FC<ImageListItemProps> = ({ children, sx, ...props }) => {
  return (
    <MuiImageListItem
      sx={{
        "& .MuiImageListItem-img": {
          height: "100%",
          width: "100%",
          overflow: "hidden"
        },
        ...sx // This allows for additional style overrides
      }}
      {...props}
    >
      {children}
    </MuiImageListItem>
  );
};

// TODO: Built this for images page to use skeleton loader, didn't actually test rendering this with images yet
const ImageList: React.FC<ImageListProps> = ({ isLoading, itemWidth = 400, children, columnCount = 2, ...props }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  const getSkeletonPhotos = () => {
    const count = elementRef.current ? elementRef.current?.getBoundingClientRect().width / itemWidth : 0;

    return (
      <Flex flexDirection="row" gap={2}>
        {Array.from({ length: Math.round(count) }).map((_, j) => (
          <MuiSkeleton key={j} variant="rectangular" height={itemWidth} width={itemWidth} />
        ))}
      </Flex>
    );
  };

  return (
    <div ref={elementRef}>
      {isLoading && getSkeletonPhotos()}
      {!isLoading && (
        <MuiImageList
          cols={columnCount}
          sx={{
            marginBlockStart: 0,
            marginBlockEnd: 0,
            paddingInlineStart: 0
          }}
          {...props}
        >
          {children}
        </MuiImageList>
      )}
    </div>
  );
};

export default ImageList;
